import script from "./loadingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./loadingPage.vue?vue&type=script&setup=true&lang=ts"

import "./loadingPage.vue?vue&type=style&index=0&id=d0f9ca10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f9ca10"]])

export default __exports__